import EmailContactItem from "./EmailContactItem";
import AddressContactItem from "./AddressContactItem";
import FaxContactItem from "./FaxContactItem";
import TelContactItem from "./TelContactItem";

export const contactTel = [
  {
    title: "Tel :",
    contentOne: "+216 70 29 49 59",
  },
];
export const contactFax = [
  {
    title: "Fax :",
    content: "+ 216 71 862 703",
  },
];
export const contactMail = [
  {
    title: "E-Mail :",
    content: "permanence@cjd.tn ",
  },
];

const centerTab = [
  {
    title: "Adresse",
    address: "Immeuble Yasmine , Rue du Lac Malaren 1053 Les Berges du Lac",
    googleMapsLink: "https://goo.gl/maps/D2RcMgjsxdyHcucU7",
  },
];

export default function Info() {
  return (
    <section>
      <div className="container flex flex-col pt-8 md:grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div className="flex flex-col gap-6">
          {contactMail.map((item, index) => (
            <EmailContactItem item={item} key={index} />
          ))}
          {contactFax.map((item, index) => (
            <FaxContactItem item={item} key={index} />
          ))}
          {contactTel.map((item, index) => (
            <TelContactItem item={item} key={index} />
          ))}
        </div>
        <div className="flex flex-col gap-6">
          {centerTab.map((item, index) => (
            <AddressContactItem item={item} key={index} />
          ))}
        </div>
        <div className="grayscale md:col-span-2 lg:col-span-1 bg-grey-bg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.2484259727858!2d10.231287115633876!3d36.83652597335316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd353e5fbeac6f%3A0x61d4c8ae615afa94!2s1053%20Lac%20Mal%C3%A4ren%2C%20Tunis!5e0!3m2!1sen!2stn!4v1663091097840!5m2!1sen!2stn"
            width="100%"
            allowFullScreen={false}
            loading="lazy"
            className="h-[281px] lg:h-full"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
